/**
 * @module Checkbox
 */

import Component from '../Component';
import './styles.css';

/**
 * Чекбоксы.
 */
export default class Checkbox extends Component {
    static className = 'checkbox';

    initElements() {
        this.elements = {
            $label: $('.checkbox__label', this.$block),
            $input: $('.checkbox__input', this.$block),
        };
    }
}
